<template>
  <div
    class="item"
    v-bind:class="{
      checked: item.checked,
      default: item.image.indexOf('getbring') > 0
    }"
  >
    <div class="count" v-if="item.count > 1">{{ item.count }}</div>
    <div>
      <md-menu
        v-if="!item.loading && item.images && item.images.length > 1"
        @click.native.stop.prevent="noop"
      >
        <md-button md-menu-trigger>
          <img :src="item.image" />
        </md-button>
        <md-menu-content>
          <md-menu-item
            v-on:selected="changeImage(image)"
            v-for="(image, index) in item.images"
            v-bind:key="index"
          >
            <img :src="image" />
          </md-menu-item>
        </md-menu-content>
      </md-menu>
      <img
        :src="item.image"
        v-if="!item.loading && (!item.images || item.images.length === 1)"
      />
      <md-spinner md-indeterminate v-if="item.loading"></md-spinner>
    </div>
    <md-menu
      v-if="item.names && item.names.length > 1"
      @click.native.stop.prevent="noop"
    >
      <md-button md-menu-trigger>{{ item.name }}</md-button>
      <md-menu-content>
        <md-menu-item
          v-on:selected="changeName(name)"
          v-for="name in item.names"
          v-bind:key="name"
          >{{ name }}</md-menu-item
        >
      </md-menu-content>
    </md-menu>
    <p v-else>{{ item.name }}</p>
  </div>
</template>

<script>
export default {
  name: "item",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    changeName(name) {
      this.$emit("name", name);
    },
    changeImage(image) {
      this.$emit("image", image);
    },
    noop() {}
  }
};
</script>

<style>
.item {
  width: 100px;
  height: 100px;
  color: black;
  background-color: white;
  margin-right: 2px;
  margin-bottom: 2px;
  flex: none;
  padding: 4px;
  text-align: center;
  position: relative;

  transition: all 1s;
}

.item .count {
  color: white;
  background-color: red;
  position: absolute;
  top: 2px;
  right: 2px;
  width: 24px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
}

.item.checked {
  opacity: 0.4;
}

.item.checked p {
  text-decoration: line-through;
}

.item img,
.md-list-item .md-menu-item img {
  max-height: 70px;
  max-width: 92px;
}

.item p {
  position: absolute;
  bottom: 4px;
  margin: 0;
  width: 92px;
  background-color: rgba(255, 255, 255, 0.53);
}

.item.default {
  background: #8bc34a;
}

.item .md-menu .md-button {
  text-transform: capitalize;
  line-height: normal;
  text-overflow: ellipsis;
  max-width: 100px;
  padding: 0;
}
</style>
